import { FormikProps } from "formik";
import React, { useEffect } from "react";
import useEnv from "../../../../../../../../hooks/env";
import LaboratoryNotificationListsApi from "../../../../../../../../api/services/LaboratoryNotificationListsApi";
import { AutocompleteSelectable } from "../../../../../../../../components/Autocomplete/AutocompleteSelectable.model";
import PagedResponse from "../../../../../../../../api/models/PagedResponse";
import { NotificationListUserResponse } from "../../../../../../../../api/models/test-request/LaboratoryNotificationLists";
import { AssignableUsersMultipleAutocomplete } from "../../../../../../../../components/Autocomplete/CustomSearchAutoComplete.instances";

export interface AssignableUsersInputFilterProps {
  laboratoryId: number;
  disabled: boolean;
  autoFocus?: boolean;
  mandatory?: boolean;
  reset?: boolean;
  formRef: React.RefObject<
    FormikProps<{
      users: {
        id: number;
        name: string;
      }[];
    }>
  >;
  values: { users: { id: number; name: string }[] };
  setFieldValue: (field: string, value: unknown, shouldValidate?: boolean) => void;
  handleSetReseting?: React.Dispatch<React.SetStateAction<boolean>>;
}

const NotificationListAssignableUsersInput: React.FC<AssignableUsersInputFilterProps> = (props) => {
  const { laboratoryId, autoFocus, disabled, mandatory, values, formRef, setFieldValue, reset, handleSetReseting } =
    props;
  const { api } = useEnv();
  const laboratoriesApi = new LaboratoryNotificationListsApi(api);

  useEffect(() => {
    if (reset && formRef && formRef.current) {
      setFieldValue("users", formRef.current.initialValues.users);
    }
    if (handleSetReseting) handleSetReseting(false);
  }, [reset, values.users]);

  const deleteTagAtIndex = (item: AutocompleteSelectable<{ id: number; name: string }>, index: number) => {
    return {
      onDelete: () => {
        setFieldValue(
          "users",
          values.users.filter((_, i) => i !== index),
        );
      },
    };
  };

  return (
    values.users && (
      <AssignableUsersMultipleAutocomplete
        autoFocus={!!autoFocus}
        disabled={disabled}
        mandatory={mandatory}
        inputLabel="Assignable Users"
        placeholder="Add User"
        map={(value): { key: string; label: string } => {
          return { key: `${value.id}`, label: `${value.name}` };
        }}
        onChange={(event, newUsers): void => {
          setFieldValue("users", newUsers);
        }}
        optionFetch={(query): Promise<PagedResponse<NotificationListUserResponse>> => {
          return laboratoriesApi.getAssignableUsersForNotificationList(query, laboratoryId).then(({ data }) => {
            return data;
          });
        }}
        value={values.users}
        getCustomTagDelete={deleteTagAtIndex}
      />
    )
  );
};

export default NotificationListAssignableUsersInput;
